export const state = {
  reload: false,
};

export const mutations = {
  SET_COMPANIES_RELOAD: (state, data) => {
    state.reload = data;
  },
};

export const actions = {
  setCompaniesReload({ commit }, payload) {
    commit("SET_COMPANIES_RELOAD", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
